<script lang="ts">
  import { getMediaPropertiesFromId } from '../utils/Media'
  import componentAttributesStore from '../stores/componentAttributes.svelte'
  import videoStore from '../stores/video.svelte'
  import PlayerContainer from './PlayerContainer.svelte'
  import BufferingScreen from './ui/BufferingScreen.svelte'
  import ErrorMessageScreen from './ui/ErrorMessageScreen.svelte'
  import VideoController from './VideoController.svelte'
  import LivePlayerUI from './ui/live/LivePlayerUI.svelte'
  import VodPlayerUI from './ui/vod/VodPlayerUI.svelte'
  import ChromecastingScreen from './ui/ChromecastingScreen.svelte'

  //let previousSrc = $state('')

  //$inspect(componentAttributesStore.state.hideControls)

  $effect(() => {
    if (
      componentAttributesStore.state.id &&
      componentAttributesStore.state.domain
    ) {
      videoStore.state.mediaDescriptor = getMediaPropertiesFromId(
        componentAttributesStore.state.id,
        componentAttributesStore.state.domain,
      )
    }
  })

  /*async function loadMediaDescriptor(src: string) {
    try {
      previousSrc = src
      videoStore.state.mediaDescriptor =
        await MediaDescriptorFactory.fromManifestUrl(src)
    } catch (error) {
      videoStore.state.errorMessage =
        'An error occurred while loading the video'
      videoStore.state.mediaDescriptor = null
      console.error('Cannot load video', error)
    }
  }*/

  export function getMuted() {
    return componentAttributesStore.state.muted
  }

  export function getVideoType() {
    return videoStore.state.videoType
  }

  export function getPlaybackRate() {
    return componentAttributesStore.state.playbackRate
  }

  export function getDuration() {
    return videoStore.state.duration
  }

  export function getIsPlaying() {
    return videoStore.state.isPlaying
  }

  export function getLoop() {
    return componentAttributesStore.state.loop
  }

  export function getVolume() {
    return componentAttributesStore.state.volume
  }

  export function getCurrentTime() {
    return videoStore.state.currentTime
  }

  export function setCurrentTime(currentTime: number) {
    return videoStore.state.videoController?.setCurrentTime(currentTime)
  }

  export function seek(time: number) {
    videoStore.state.videoController?.seek(time)
  }

  export function setVolume(volume: number) {
    return videoStore.state.videoController?.setVolume(volume)
  }

  export function setMuted(muted: boolean) {
    return videoStore.state.videoController?.setMuted(muted)
  }

  export function play() {
    videoStore.state.videoController?.play()
  }

  export function pause() {
    videoStore.state.videoController?.pause()
  }

  export function requestFullscreen() {
    videoStore.state.videoController?.requestFullscreen()
  }

  export function exitFullscreen() {
    videoStore.state.videoController?.exitFullscreen()
  }

  export function download(filename?: string) {
    videoStore.state.videoController?.downloadMp4(filename)
  }

  export function getMp4Url() {
    return videoStore.state.mediaDescriptor?.mp4Url
  }

  export function getVideoSize() {
    return {
      width: videoStore.state.videoWidth,
      height: videoStore.state.videoHeight,
    }
  }

  export function exitPictureInPicture() {
    videoStore.state.videoController?.exitPictureInPicture()
  }

  export function requestPictureInPicture() {
    videoStore.state.videoController?.requestPictureInPicture()
  }

  export function addEventListener(
    type: string,
    listener: EventListenerOrEventListenerObject,
    options?: boolean | AddEventListenerOptions,
  ) {
    videoStore.state.videoController?.addEventListener(type, listener, options)
  }
</script>

<PlayerContainer>
  <VideoController bind:this={videoStore.state.videoController} />
  {#if videoStore.state.errorMessage}
    <ErrorMessageScreen />
  {:else}
    <ChromecastingScreen />
    <BufferingScreen />
    {#if videoStore.state.mediaDescriptor?.mediaType === 'live'}
      <LivePlayerUI />
    {:else}
      <VodPlayerUI />
    {/if}
  {/if}
</PlayerContainer>

<svelte:document
  on:fullscreenchange={() =>
    (videoStore.state.isFullscreen = !!document.fullscreenElement)}
/>

<!-- svelte-ignore css_unused_selector -->
<style lang="postcss" global>
  @tailwind base;
  @tailwind components;
  @tailwind utilities;

  .text-shadow {
    text-shadow: #000000 0 0 5px;
  }
</style>
